module.exports = __webpack_public_path__ + "img/product-test.f544da22.jpg";